import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'

import { Edit } from '@styled-icons/boxicons-solid'

import DtcMappings from './DtcMappings'
import DtcRow from './DtcRow'
import { useNavigate } from 'react-router-dom'

const humanizeBool = (bool) => (bool ? 'Yes' : 'No')

const DtcRowExtended = ({
  id,
  name,
  ecu,
  active,
  destination_only,
  mappings,
  vehicleSid,
  short_description,
  description,
}) => {
  const navigate = useNavigate()

  const [showMappings, setShowMappings] = useState(false)

  const startConnectorMappings = mappings?.['start'] || []
  const endConnectorMappings = mappings?.['end'] || []
  const devices = mappings?.['devices'] || []
  const mappingsCount = isEmpty(mappings)
    ? 0
    : startConnectorMappings.length +
      endConnectorMappings.length +
      devices.length
  const editUrl = `/vehicles/${vehicleSid}/dtcs/listing/${id}/edit`

  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex w-2/12 items-center">
        <DtcRow
          dtcId={id}
          className="pl-2 py-2 float-left"
          destination_only={destination_only}
          name={name}
          ecu={ecu}
        />
        <span className="pl-5 break-all">{name}</span>
      </div>
      <div className="w-3/12 pl-6 break-all">{short_description}</div>
      <div className="w-3/12 pl-6 break-all">{description}</div>
      <div className="w-1/12 pl-6 break-all">{ecu}</div>
      <div className="w-1/12 pl-6">{humanizeBool(active)}</div>
      <div className="w-1/12 pl-6 py-2">{humanizeBool(destination_only)}</div>
      <div className="flex w-1/12 pl-2 block">
        <div className="w-9/12">
          {mappingsCount > 0 && (
            <span
              className="text-sm cursor-pointer inline-block text-blue-500 underline py-1"
              onClick={() => setShowMappings(!showMappings)}
            >
              {showMappings ? 'Hide' : 'Show'}, {mappingsCount}
            </span>
          )}
        </div>
        <div>
          <span
            onClick={() => {
              navigate(editUrl)
            }}
            className="cursor-pointer"
          >
            <Edit size="2rem" color="#0189E9" />
          </span>
        </div>
      </div>
      <div
        className={
          showMappings
            ? 'w-full bg-gray-100 border border-gray-200 block flex flex-row mt-6 p-4 rounded'
            : 'hidden'
        }
      >
        <DtcMappings title="Start" mappings={startConnectorMappings} />
        <DtcMappings title="End" mappings={endConnectorMappings} />
        <DtcMappings title="Devices" mappings={devices} />
      </div>
    </div>
  )
}

DtcRowExtended.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string,
  ecu: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  destination_only: PropTypes.bool.isRequired,
  mappings: PropTypes.object,
}

export default DtcRowExtended
